import React from 'react';

import { useInterimListScroll } from '../translation/hooks/useInterimListScroll';

import styles from './ListView.module.scss';

/**
 * プロパティ
 */
export type InterimView = {
  // CSSを反転するか否か
  isReversed: boolean;
  // 言語コード
  langCode: string;
  // 暫定テキスト
  text: string;
  // 暫定テキストを左方向に自動スクロールするか否か(true=自動スクロールする)
  isAutoLeftScrollInterimText: boolean;
  // RTL表示するか否か
  isRTL: boolean;
};

/**
 * 暫定テキストビュー コンポーネント
 */
export const InterimView = React.memo(
  ({
    isReversed,
    langCode,
    text,
    isAutoLeftScrollInterimText,
    isRTL,
  }: InterimView) => {
    const autoScroll = useInterimListScroll({
      isAutoLeftScroll: isAutoLeftScrollInterimText,
    });

    return (
      <div
        lang={langCode}
        className={`${styles.raw} ${styles.translated} ${styles.interim} ${
          isReversed ? styles['interim-reversed'] : ''
        } ${isRTL ? styles['text-rtl'] : ''}
         ${text === '...' ? styles['profanity-processing'] : ''}`}
        ref={autoScroll.interimListRef}
      >
        {text}
      </div>
    );
  },
);
